import HolidayCalendar from "../../entities/holidayCalendar";

/**
 * HolidayCalendar actions
 *
 * Call order:
 *
 * HOLIDAYCALENDAR_SAVE_QUEUE:	adds the item to the save queue
 * --> HOLIDAYCALENDAR_SAVE:	modifies the state
 * --> HOLIDAYCALENDAR_SAVE_SUCCESS: if all went well
 * --> HOLIDAYCALENDAR_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail HOLIDAYCALENDAR_SAVE_QUEUE is during the call to HOLIDAYCALENDAR_SAVE,
 * as adding an item to the queue should never fail.
 */

export const HOLIDAYCALENDAR_FETCH_ONE_QUEUE: any = 'HOLIDAYCALENDAR_FETCH_ONE_QUEUE';
export const HOLIDAYCALENDAR_FETCH_SUCCESS: any = 'HOLIDAYCALENDAR_FETCH_SUCCESS';
export const HOLIDAYCALENDAR_FETCH_FAILURE: any = 'HOLIDAYCALENDAR_FETCH_FAILURE';
export const HOLIDAYCALENDAR_FETCH_ONE_SUCCESS: any = 'HOLIDAYCALENDAR_FETCH_ONE_SUCCESS';
export const HOLIDAYCALENDAR_FETCH_ONE_FAILURE: any = 'HOLIDAYCALENDAR_FETCH_ONE_FAILURE';

export const HOLIDAYCALENDAR_SAVE: any = 'HOLIDAYCALENDAR_SAVE';
export const HOLIDAYCALENDAR_SAVE_QUEUE: any = 'HOLIDAYCALENDAR_SAVE_QUEUE';
export const HOLIDAYCALENDAR_SAVE_SUCCESS: any = 'HOLIDAYCALENDAR_SAVE_SUCCESS';
export const HOLIDAYCALENDAR_SAVE_FAILURE: any = 'HOLIDAYCALENDAR_SAVE_FAILURE';

export const HOLIDAYCALENDAR_SAVE_MANY: any = 'HOLIDAYCALENDAR_SAVE_MANY';
export const HOLIDAYCALENDAR_SAVE_MANY_QUEUE: any = 'HOLIDAYCALENDAR_SAVE_MANY_QUEUE';
export const HOLIDAYCALENDAR_SAVE_MANY_SUCCESS: any = 'HOLIDAYCALENDAR_SAVE_MANY_SUCCESS';
export const HOLIDAYCALENDAR_SAVE_MANY_FAILURE: any = 'HOLIDAYCALENDAR_SAVE_MANY_FAILURE';

export const HOLIDAYCALENDAR_REMOVE: any = 'HOLIDAYCALENDAR_REMOVE';
export const HOLIDAYCALENDAR_REMOVE_QUEUE: any = 'HOLIDAYCALENDAR_REMOVE_QUEUE';
export const HOLIDAYCALENDAR_REMOVE_SUCCESS: any = 'HOLIDAYCALENDAR_REMOVE_SUCCESS';
export const HOLIDAYCALENDAR_REMOVE_FAILURE: any = 'HOLIDAYCALENDAR_REMOVE_FAILURE';

export const HOLIDAYCALENDAR_RESTORE: any = 'HOLIDAYCALENDAR_RESTORE';
export const HOLIDAYCALENDAR_RESTORE_QUEUE: any = 'HOLIDAYCALENDAR_RESTORE_QUEUE';
export const HOLIDAYCALENDAR_RESTORE_SUCCESS: any = 'HOLIDAYCALENDAR_RESTORE_SUCCESS';
export const HOLIDAYCALENDAR_RESTORE_FAILURE: any = 'HOLIDAYCALENDAR_RESTORE_FAILURE';

export const HOLIDAYCALENDAR_RESTORE_MANY: any = 'HOLIDAYCALENDAR_RESTORE_MANY';
export const HOLIDAYCALENDAR_REMOVE_MANY: any = 'HOLIDAYCALENDAR_REMOVE_MANY';

/* Fetch actions */
export const fetchHolidayCalendarSuccess = (holidayCalendars: HolidayCalendar[], partial: boolean, lastFetch: number) => ({type: HOLIDAYCALENDAR_FETCH_SUCCESS, holidayCalendars, partial, lastFetch});
export const fetchHolidayCalendarFailure = (err: any) => {
		console.error('HolidayCalendarAction: fetchHolidayCalendarFailure', err);
		return {type: HOLIDAYCALENDAR_FETCH_FAILURE, err};
};
export const fetchOneHolidayCalendarQueue = (holidayCalendarId: string) => ({type: HOLIDAYCALENDAR_FETCH_ONE_QUEUE, holidayCalendarId});
export const fetchOneHolidayCalendarSuccess = (holidayCalendar: HolidayCalendar) => ({type: HOLIDAYCALENDAR_FETCH_ONE_SUCCESS, holidayCalendar});
export const fetchOneHolidayCalendarFailure = (id: string, err: any) => {
		console.error('HolidayCalendarAction: fetchOneHolidayCalendarFailure', err);
		return {type: HOLIDAYCALENDAR_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveHolidayCalendar = (holidayCalendar: HolidayCalendar) => {
    // console.debug('⮂ HOLIDAYCALENDAR_SAVE action', holidayCalendar?.id);
    return {type: HOLIDAYCALENDAR_SAVE, holidayCalendar};
}
export const saveHolidayCalendarQueue = (holidayCalendar: HolidayCalendar, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ HOLIDAYCALENDAR_SAVE_QUEUE action', holidayCalendar?.id);
    return {type: HOLIDAYCALENDAR_SAVE_QUEUE, holidayCalendar, onQueued};
}
export const saveHolidayCalendarSuccess = (holidayCalendar: HolidayCalendar) => {
    // console.debug('⮂ HOLIDAYCALENDAR_SAVE_SUCCESS action', holidayCalendar?.id);
    return {type: HOLIDAYCALENDAR_SAVE_SUCCESS, holidayCalendar};
}
export const saveHolidayCalendarFailure = (holidayCalendar: HolidayCalendar, status: number, message: string) => {
    console.warn(`⮂ HOLIDAYCALENDAR_SAVE_FAILURE error saving holidayCalendar: HTTP ${status}: ${message}`, holidayCalendar?.id);
    return {type: HOLIDAYCALENDAR_SAVE_FAILURE, holidayCalendar, status, message};
};

/* SaveMany actions */
export const saveManyHolidayCalendars = (holidayCalendars: HolidayCalendar[]) => {
    // console.debug('⮂ HOLIDAYCALENDAR_SAVE_MANY action', holidayCalendars?.map(holidayCalendar => holidayCalendar?.id).join(','));
    return {type: HOLIDAYCALENDAR_SAVE_MANY, holidayCalendars};
}
export const saveManyHolidayCalendarsQueue = (holidayCalendars: HolidayCalendar[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ HOLIDAYCALENDAR_SAVE_MANY_QUEUE action', holidayCalendars?.map(holidayCalendar => holidayCalendar.id).join(','));
    return {type: HOLIDAYCALENDAR_SAVE_MANY_QUEUE, holidayCalendars, onQueued};
}

export const saveManyHolidayCalendarsSuccess = (holidayCalendars: HolidayCalendar[]) => {
    // console.debug('⮂ HOLIDAYCALENDAR_SAVE_MANY_SUCCESS action', holidayCalendars?.map(holidayCalendar => holidayCalendar.id).join(','));
    return {type: HOLIDAYCALENDAR_SAVE_MANY_SUCCESS, holidayCalendars};
}
export const saveManyHolidayCalendarsFailure = (holidayCalendars: HolidayCalendar[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_HOLIDAYCALENDARS_FAILURE Error saving holidayCalendars: HTTP ${status}: ${message}`, holidayCalendars?.map(holidayCalendar => holidayCalendar.id).join(','));
		return {type: HOLIDAYCALENDAR_SAVE_MANY_FAILURE, holidayCalendars, status, message};
};

/* Remove actions */
export const removeHolidayCalendar = (holidayCalendar: HolidayCalendar) => ({ type: HOLIDAYCALENDAR_REMOVE, holidayCalendar });
export const removeHolidayCalendarQueue = (holidayCalendar: HolidayCalendar) => ({ type: HOLIDAYCALENDAR_REMOVE_QUEUE, holidayCalendar });
export const removeHolidayCalendarSuccess = (holidayCalendar: HolidayCalendar) => ({ type: HOLIDAYCALENDAR_REMOVE_SUCCESS, holidayCalendar });
export const removeHolidayCalendarFailure = (holidayCalendar: HolidayCalendar, status: number, message: string) => {
	console.error(`Redux: removeHolidayCalendarFailure Error removing holidayCalendar: HTTP ${status}: ${message}`);
	return ({ type: HOLIDAYCALENDAR_REMOVE_FAILURE, holidayCalendar, status, message });
};

/* Restore actions */
export const restoreHolidayCalendar = (holidayCalendar: HolidayCalendar) => ({ type: HOLIDAYCALENDAR_RESTORE, holidayCalendar });
export const restoreHolidayCalendarQueue = (holidayCalendar: HolidayCalendar) => ({ type: HOLIDAYCALENDAR_RESTORE_QUEUE, holidayCalendar });
export const restoreHolidayCalendarSuccess = (holidayCalendar: HolidayCalendar) => ({ type: HOLIDAYCALENDAR_RESTORE_SUCCESS, holidayCalendar });
export const restoreHolidayCalendarFailure = (holidayCalendar: HolidayCalendar, status: number, message: string) => {
	console.error(`Redux: restoreHolidayCalendarFailure Error restoring holidayCalendar: HTTP ${status}: ${message}`);
	return ({ type: HOLIDAYCALENDAR_RESTORE_FAILURE, holidayCalendar, status, message });
};

/* RestoreMany actions */
export const restoreManyHolidayCalendars = (holidayCalendars: HolidayCalendar[]) => ({ type: HOLIDAYCALENDAR_RESTORE_MANY, holidayCalendars });

/* RemoveMany actions */
export const removeManyHolidayCalendars = (holidayCalendars: HolidayCalendar[]) => ({ type: HOLIDAYCALENDAR_REMOVE_MANY, holidayCalendars });